import { useEffect } from 'react';
import { Eye } from 'lucide-react';
import { useVehicleViews } from '@/hooks/useVehicleViews';

interface ViewCounterProps {
  vehicleId: string;
}

export const ViewCounter = ({ vehicleId }: ViewCounterProps) => {
  const { weeklyViews, recordView, isLoading } = useVehicleViews(vehicleId);

  // Enregistrer une vue au chargement du composant
  useEffect(() => {
    recordView();
  }, [recordView]);

  if (isLoading) return null;

  return (
    <div className="flex items-center gap-2 text-sm text-muted-foreground">
      <Eye className="h-4 w-4" />
      <span>
        {weeklyViews > 0 ? (
          <>
            <strong className="text-foreground">{weeklyViews}</strong> {weeklyViews === 1 ? 'personne a' : 'personnes ont'} consulté cette annonce cette semaine
          </>
        ) : (
          "Soyez le premier à consulter cette annonce"
        )}
      </span>
    </div>
  );
};
